import { PageMap } from '@wix/wixstores-client-core';
import { SPECS } from '../../constants';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import type { CheckoutInfo, NavigateToCheckoutArgs } from '../types';

function truthyUrlParams(
  obj: Record<string, string | boolean | undefined>,
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, value]) => !!value)
      .map(([key, value]) => [key, String(value)]),
  );
}

function checkoutInfoToUrlParams(
  context: EcomPlatformViewerScriptContext,
  origin: string,
  checkoutInfo: CheckoutInfo,
): Record<string, string> {
  const sendOrigin = !context.siteStore.experiments.enabled(
    SPECS.StopSendingOriginInCheckoutUrl,
  );
  const isPickupFlow = checkoutInfo.isPickupFlow ?? checkoutInfo.isPickupOnly;

  return truthyUrlParams({
    checkoutId: checkoutInfo.checkoutId,
    cashierPaymentId: checkoutInfo.cashierPaymentId,
    ...(sendOrigin && { origin }),
    successUrl: checkoutInfo.successUrl,
    isPickupFlow,
    continueShoppingUrl: checkoutInfo.continueShoppingUrl,
    isPreselectedFlow: checkoutInfo.isPreselectedFlow,
    contentAppId: checkoutInfo.contentAppId,
    contentComponentId: checkoutInfo.contentComponentId,
    disableContinueShopping: checkoutInfo.disableContinueShopping,
  });
}

export const toCheckout =
  ({
    context,
    origin,
  }: {
    context: EcomPlatformViewerScriptContext;
    origin: string;
  }) =>
  (args: NavigateToCheckoutArgs): Promise<void> => {
    const params: CheckoutInfo = {
      cashierPaymentId: args.paymentId,
      checkoutId: args.checkoutId,
      locale: context.siteStore.locale,
      isPickupOnly: false,
      isPreselectedFlow: args.isPreselectedFlow ?? false,
      continueShoppingUrl: args.continueShoppingUrl,
      disableContinueShopping: args.disableContinueShopping,
      successUrl: args.successUrl,
      contentAppId: args.contentAppId,
      contentComponentId: args.contentComponentId,
    };
    context.siteStore.navigate(
      {
        sectionId: PageMap.CHECKOUT,
        urlParams: checkoutInfoToUrlParams(context, origin, params),
      },
      true,
    );
    return Promise.resolve();
  };
